// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__JLC0f","tooltip-box":"tooltip_tooltip-box__+hvvz","tooltip-arrow":"tooltip_tooltip-arrow__6Zkfl","visible":"tooltip_visible__Sb-v3"};